import { FC, ReactNode } from 'react'
import { Download, DownloadType } from './Download'
import { CampaignEmployeeCard, CampaignEmployeeCardType } from './EmployeeCard'
import { CampaignManagerCard, CampaignManagerCardType } from './ManagerCard'
import { CampaignEmployeeStatus, CampaignEmployeeStatusType } from './Status'

export const CampaignEmployee: FC &
  CampaignEmployeeCardType &
  CampaignManagerCardType &
  CampaignEmployeeStatusType &
  DownloadType = (): ReactNode => <></>

CampaignEmployee.EmployeeCard = CampaignEmployeeCard
CampaignEmployee.ManagerCard = CampaignManagerCard
CampaignEmployee.Status = CampaignEmployeeStatus
CampaignEmployee.Download = Download
